import { archiveFeed, archiveMore } from "@/mocks/home";

const tagClass: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function Archive() {
  return (
    <section id="archive" className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5">
          <div>
            <p className="text-xs font-bold tracking-[0.22em] text-secondary-800">ARCHIVE · 大图实录流</p>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black tracking-tight text-foreground-950">
              翻车现场实录
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              今日与本周的高能现场，按时间归档。点开任意一帧，都是完整的翻车记录。
            </p>
          </div>
          <a
            href="#join"
            className="inline-flex w-fit items-center gap-1.5 rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm font-semibold whitespace-nowrap hover:bg-background-100"
          >
            全部实录档案
            <i className="ri-arrow-right-line text-base" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-[1fr_0.48fr] gap-6">
          <div className="flex flex-col gap-4 md:gap-5">
            {archiveFeed.map((a) => (
              <article
                key={a.title}
                className="group flex flex-col sm:flex-row overflow-hidden rounded-xl border border-background-200 bg-background-50"
              >
                <div className="relative shrink-0 overflow-hidden sm:w-64 aspect-[16/10] sm:aspect-auto">
                  <img
                    src={a.cover}
                    alt={`${a.title}，51大雷翻车实录`}
                    className="group-img h-full w-full object-cover object-top"
                  />
                </div>
                <div className="flex flex-1 flex-col p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={`rounded-md px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap ${tagClass[a.tagStyle]}`}>
                      {a.category}
                    </span>
                    <span className="flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
                      <i className="ri-time-line" />
                      {a.time}
                    </span>
                  </div>
                  <h3 className="mt-2 font-heading text-lg md:text-xl font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                    {a.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{a.summary}</p>
                  <div className="mt-auto flex items-center justify-between pt-3">
                    <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-eye-line" />
                        {a.views}
                      </span>
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-heart-3-line" />
                        {a.likes}
                      </span>
                    </div>
                    <span className="flex items-center gap-1 text-xs font-semibold text-foreground-800 whitespace-nowrap">
                      查看完整实录
                      <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <aside className="flex flex-col rounded-xl border border-background-200 bg-background-50">
            <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">本周补刀档案</h3>
              <span className="rounded-full bg-secondary-100 text-secondary-800 px-2.5 py-1 text-[11px] font-semibold whitespace-nowrap">
                {archiveMore.length} 条
              </span>
            </div>
            <div className="flex flex-col">
              {archiveMore.map((m, idx) => (
                <a
                  key={m.title}
                  href="#archive"
                  className={`group flex gap-3 p-4 md:p-5 hover:bg-background-100 ${idx !== archiveMore.length - 1 ? "border-b border-background-200" : ""}`}
                >
                  <span className="font-heading text-2xl font-black leading-none text-secondary-300">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <div className="min-w-0">
                    <h4 className="text-sm font-semibold leading-snug text-foreground-950 group-hover:text-primary-700">
                      {m.title}
                    </h4>
                    <div className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-500">
                      <span className="whitespace-nowrap">{m.category}</span>
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-time-line" />
                        {m.time}
                      </span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}